
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { uiStore } from "@/store/store";
import defensiveCopy from "@/util/defensive-copy";

@Component({
  components: {}
})
export default class ElementStudioDefaultProperties extends Vue {
  @Prop()
  value!: unknown | false; // BuilderElementDefaultPropertiesV is unknown

  @Prop()
  elementSlug!: string;

  dialogOpen = false;

  defaultProperties = this.value;

  get canImport() {
    if (!uiStore.activeElement) return false;
    return uiStore.activeElement.data.type === this.elementSlug;
  }

  cancel() {
    this.dialogOpen = false;
  }

  importDefaultProperties() {
    if (!uiStore.activeElement) return;
    if (uiStore.activeElement.data.type !== this.elementSlug) return;

    const defaultProperties = defensiveCopy(
      uiStore.activeElement.data.properties
    );

    if (defaultProperties) {
      if ("settings" in defaultProperties) {
        delete defaultProperties.settings;
      }

      if ("meta" in defaultProperties) {
        delete defaultProperties.meta;
      }
    }

    this.defaultProperties = defaultProperties;

    this.dialogOpen = true;
  }

  confirmDefaultProperties() {
    this.dialogOpen = false;
    this.$emit("input", this.defaultProperties);
  }

  clearDefaultProperties() {
    if (confirm("are you sure?")) {
      this.$emit("input", false);
    }
  }
}
